
import { RxDashboard } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";
import { LuUsers } from "react-icons/lu";
import { FaRegChartBar } from "react-icons/fa";
import { LuRecycle } from "react-icons/lu";
import { PiFactory } from "react-icons/pi";
import { IoConstructOutline } from "react-icons/io5";


export const menuItems = [
    {
        key: "dashboard",
        title: "Dashboard",
        icon: RxDashboard,
        path: "/dashboard"
    },
    {
        key: "administracion",
        title: "Administración",
        icon: IoSettingsOutline ,
        hasSubmenu: true,
        submenu: [
            { title: "Países", path: "/administracion/paises" },
            { title: "Comunidades", path: "/administracion/comunidades" },
            { title: "Provincias", path: "/administracion/provincias" },
            { title: "Productores", path: "/administracion/productores" },
            { title: "Intermediarios", path: "/administracion/intermediarios" },
            { title: "Usuarios", path: "/administracion/usuarios" }
        ]
    },
    {
        key: "gestores",
        title: "Gestores",
        icon: LuUsers,
        path: "/gestores"
    },
    {
        key: "informes",
        title: "Informes",
        icon: FaRegChartBar,
        hasSubmenu: true,
        submenu: [
            { title: "Cantidades generadas", path: "/informes/cantidades-generadas" },
            { title: "Costes", path: "/informes/costes" },
            { title: "Segregación y valorización", path: "/informes/segregacion-valorizacion" },
            { title: "Huella de carbono", path: "/informes/huella-carbono" }
        ]
    },
    {
        key: "residuos",
        title: "Residuos",
        icon: LuRecycle,
        path: "/residuos"
    },
    {
        key: "centros-productores",
        title: "Centros productores",
        icon: PiFactory ,
        path: "/centros-productores"
    },
    {
        key: "obras-menores",
        title: "Obras menores",
        icon: IoConstructOutline ,
        path: "/obras-menores"
    }
];